export enum ContactType {
	Customer = 1,
	Assignee,
	Vendor,
	BoardMember
}
